import { Box, Heading, Text, List, ListItem } from '@chakra-ui/react'

const ImplementationSteps = () => (
  <Box>
    <Heading as="h4" size="md" mt={6} mb={2}>
      Step-by-Step Implementation Process
    </Heading>
    <List spacing={3} mb={4}>
      <ListItem>
        <Text as="b">Step 1: Data Collection and Preparation</Text>
        <List ml={4} styleType="disc" spacing={1}>
          <ListItem><Text fontSize="sm">Gather daily sentiment data (Very Bad, Bad, Normal, Good, Very Good)</Text></ListItem>
          <ListItem><Text fontSize="sm">Record Bitcoin closing prices</Text></ListItem>
          <ListItem><Text fontSize="sm">Calculate the Good/Very Bad ratio daily</Text></ListItem>
        </List>
      </ListItem>
       <ListItem>
        <Text as="b">Step 2: Generating Trading Signals</Text>
        <List ml={4} spacing={2}>
           <ListItem>
              <Text fontSize="sm" fontWeight="bold">BUY when:</Text>
              <List ml={4} styleType="circle" spacing={1}>
                 <ListItem><Text fontSize="sm">Good/Very Bad ratio is above 1.0</Text></ListItem>
                 <ListItem><Text fontSize="sm">Ratio is showing improvement over recent days</Text></ListItem>
                 <ListItem><Text fontSize="sm">Bitcoin price is not significantly overextended</Text></ListItem>
              </List>
           </ListItem>
           <ListItem>
              <Text fontSize="sm" fontWeight="bold">SELL when:</Text>
              <List ml={4} styleType="circle" spacing={1}>
                 <ListItem><Text fontSize="sm">Good/Very Bad ratio falls below 1.0</Text></ListItem>
                 <ListItem><Text fontSize="sm">Ratio shows deterioration over multiple days</Text></ListItem>
                 <ListItem><Text fontSize="sm">Stop loss or profit target is hit</Text></ListItem>
              </List>
           </ListItem>
        </List>
      </ListItem>
    </List>
  </Box>
)

export default ImplementationSteps
